/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {calculateOvertimeForTimecard} from '../api'

export const useMutationCalculateOvertimeForTimecard = createReactQueryMutationHook('calculateOvertimeForTimecard', calculateOvertimeForTimecard)
